// CoreUI modals set aria-hidden="true" on .modal as soon as they hide, but the
// last focused control (e.g. a Cancel button) may still hold focus while the
// fade-out runs. Chrome flags this as "Blocked aria-hidden on an element
// because its descendant retained focus". Blur the focused descendant the
// moment the modal is hidden so focus is never trapped in a hidden subtree.
const observeModalA11y = () => {
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (
        mutation.type !== 'attributes' ||
        mutation.attributeName !== 'aria-hidden'
      ) {
        continue
      }
      const el = mutation.target
      if (
        !(el instanceof HTMLElement) ||
        !el.classList.contains('modal') ||
        el.getAttribute('aria-hidden') !== 'true'
      ) {
        continue
      }
      const active = document.activeElement
      if (active && el.contains(active)) {
        active.blur()
      }
    }
  })
  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  })
}

export { observeModalA11y }
